import { getCart } from "./localstorage";

export function getDiscountPercent(discountCode) {
  const match = discountCode?.match(/^(\d{1,2})%OFF$/);
  return match ? Number(match[1]) : 0;
}

export function getFixedDiscount(discountCode) {
  const match = discountCode?.match(/^(\d{1,2})%OFF$/);
  if (!match) return 0;

  const cartProducts = getCart()?.filter(({ product }) => product?.Sku);
  const hasTargetSku = cartProducts?.some(
    ({ product }) => product.Sku === "RCBandSt1"
  );

  return hasTargetSku ? 50 : 0;
}
